<mat-toolbar class="mb-4 mat-elevation-z6" color="primary">
  <span>Print Check</span>
</mat-toolbar>

<form [formGroup]="printForm">
  <div class="container">
    <h2>Print Form</h2>
    <div class="row">
      <div class="col-lg-4 col-md-8">
        <mat-form-field class="w100" appearance="fill">
          <mat-label>Employee</mat-label>
          <input
            type="text"
            placeholder="Employee"
            aria-label="Employee"
            matInput
            [formControl]="employee"
            [matAutocomplete]="auto"
            #inputAutoComplete
            />
          @if (employee.value) {
            <button
              type="button"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="clearEmployeeInput()"
              >
              <mat-icon>close</mat-icon>
            </button>
          }
          <mat-autocomplete
            #auto="matAutocomplete"
            [displayWith]="getEmployeeName"
            >
            @for (employee of filteredOptions | async; track employee) {
              <mat-option [value]="employee">{{employee.name}}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="col-lg-2 col-md-4">
        <mat-form-field appearance="fill" class="w100">
          <mat-label>Amount</mat-label>
          <span matTextPrefix style="padding-right: 5px;">$</span>
          <input
            placeholder="0"
            formControlName="amount"
            matInput
            type="number"
            class="example-right-align"
            />
        </mat-form-field>
      </div>
      <div class="col-lg-2 col-md-4">
        <mat-form-field appearance="fill" class="w100">
          <mat-label>Choose a date</mat-label>
          <input
            matInput
            [matDatepicker]="dp"
            formControlName="date"
            placeholder="Date"
            />
          <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
          <mat-datepicker #dp></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-8">
        <mat-form-field appearance="fill" class="w100">
          <mat-label>Location</mat-label>
          <mat-select formControlName="location" name="location">
            <mat-option>--</mat-option>
            @for (location of locations; track location) {
              <mat-option [value]="location">
                {{ location.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="offset-lg-4 col-lg-8">
        <mat-form-field appearance="fill" class="w100">
          <mat-label>Additional comments</mat-label>
          <textarea
            matInput
            rows="6"
            placeholder="Notes about the check"
            formControlName="notes"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <button
        type="button"
        mat-raised-button
        color="primary"
        printSectionId="print-section"
        styleSheetFile="assets/css/pdf.css"
        ngxPrint
        >
        Print Check
        <mat-icon aria-hidden="false" aria-label="print check">print</mat-icon>
      </button>
    </div>

    <div id="print-section">
      <div class="employee">{{ employee.value?.name }}</div>
      <div class="date">
        {{ date.value | date: "MM/d/yyyy" }}
      </div>
      <div class="amount">
        {{ amount?.value | number: "2.2-4" }}
      </div>
      <div class="amount-text">
        {{ amount?.value | numberToText }}
        {{
        amount?.value | decimalOnly
        }}/100***********************************************************************************************************
      </div>
      <div class="address">
        <div>{{ employee?.value?.name }}</div>
        <div [innerHTML]="employee?.value?.address"></div>
      </div>

      <div class="summary-date">
        {{ printForm.get("date")?.value | date: "MM/d/yyyy" }}
      </div>
      <div class="summary-employee">
        {{ employee?.value?.name }}
      </div>
      @if (location?.value) {
        <div class="summary-servicename">
          Speech Services at {{ location?.value?.name }}
        </div>
      }

      <div class="summary-amount">
        {{ amount?.value | number: "2.2-4" }}
      </div>
      <div class="summary-notes" [innerText]="notes?.value"></div>

      <!-- COPY -->
      <div class="summary-date-copy">
        {{ printForm.get("date")?.value | date: "MM/d/yyyy" }}
      </div>
      <div class="summary-employee-copy">
        {{ employee?.value?.name }}
      </div>
      @if (location?.value) {
        <div class="summary-servicename-copy">
          Speech Services at {{ location?.value?.name }}
        </div>
      }

      <div class="summary-amount-copy">
        {{ amount?.value | number: "2.2-4" }}
      </div>
      <div class="summary-notes-copy" [innerText]="notes?.value"></div>
    </div>
  </div>
</form>
